import React from 'react';
import { CtaButton } from './CtaButton';
import { authorImage } from '../data/content';
const questions = ['What should you assess first?', 'Which characteristics matter most?', 'What material properties should you consider?', 'How should the layering strategy be organized?', 'What sequence makes sense for the case?', 'How do you review the final result?'];
export function About() {
  return <section className="w-full bg-white px-5 py-16 sm:px-8 md:py-20" data-id="element-19" data-mp="33q6ugfxgu6yz">
      <div className="mx-auto grid max-w-4xl gap-8 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:items-start lg:gap-10" data-id="element-20" data-mp="38q2ygf65xyej">
        <div className="overflow-hidden rounded-3xl border border-ink/10 bg-cream" data-id="element-21" data-mp="3di461nsdz0y8">
          <img src={authorImage} alt="Dr. Karito in her dental clinic" className="block aspect-[3/4] w-full object-cover object-top" width={944} height={1259} data-id="element-22" data-mp="3hj6bimcwc98n" />
        </div>

        <div data-id="element-23" data-mp="3rh3twt82rbtc">
          <p className="text-[12px] font-extrabold uppercase tracking-[0.16em] text-gold-deep" data-id="element-24" data-mp="3rehop08np8ea">
            🦷 About the author
          </p>
          <h2 className="mt-3 font-display text-[28px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-25" data-mp="2gruuhifiksys">
            Dr. Karito
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-clay" data-id="element-26" data-mp="2cqssitu7q2t4">
            For years, Dr. Karito noticed the same challenge among dentists working with anterior
            composite restorations: it wasn’t always a lack of knowledge. Often, the problem was
            having to make too many decisions at the same time.
          </p>

          <ul className="mt-6 space-y-2.5" data-id="element-27" data-mp="2vp51aeh7pao6">
            {questions.map(question => <li key={question} className="border-l-2 border-gold/60 pl-4 font-display text-[16px] italic text-ink/80" data-id="element-28" data-mp="2qqbsv0gs89uv">
                {question}
              </li>)}
          </ul>

          <p className="mt-6 text-[15px] leading-relaxed text-clay" data-id="element-29" data-mp="3je7jpojo77jq">
            That experience led to the creation of Resin Architect™. Not another endless course.
            Not another theory-heavy textbook. A visual clinical reference and planning system
            built to help dentists organize the decisions involved in anterior composite cases.
          </p>

          <p className="mt-6 rounded-2xl bg-cream px-5 py-5 font-display text-[19px] font-bold italic leading-snug text-ink sm:text-[22px]" data-id="element-30" data-mp="1elnrk5zar2r">
            “Less scattered information. More structure for better clinical decision-making.”
          </p>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-31" data-mp="3ak1wixi2ongz">
        <CtaButton label="Start planning with the system" data-id="element-32" data-mp="3aldbzukvrjnx" />
      </div>
    </section>;
}